import React from 'react';
import AppBootstrapBoundary from './AppBootstrapBoundary';
import PageLoader from './shared/ui/PageLoader';
import './shared/ui/PageLoader.css';

const loadCurrentApplication = () => import('./AuthenticatedApplication');

function AppBootstrapLoadingStatus() {
  return (
    <PageLoader fullScreen />
  );
}

export default function App() {
  const [Application, setApplication] = React.useState(() => React.lazy(loadCurrentApplication));
  const [attempt, setAttempt] = React.useState(0);
  const retry = () => {
    // Only a user action creates a fresh lazy promise for the same current
    // import. Never replay an operation, select another build or auto-retry.
    setApplication(() => React.lazy(loadCurrentApplication));
    setAttempt(value => value + 1);
  };
  return (
    <AppBootstrapBoundary key={attempt} onRetry={retry}>
    <React.Suspense fallback={<AppBootstrapLoadingStatus />}>
      <Application />
    </React.Suspense>
    </AppBootstrapBoundary>
  );
}

export const APP_BOOTSTRAP_CONTRACT = Object.freeze({
  owner: 'App.js',
  authenticatedApplicationOwner: 'AuthenticatedApplication.js',
  loading: 'route-lazy',
});
